import {remCalc} from '../../theme/_utils'

export const getGradient = (variant, imageUrl) => {
    const gradient =
        variant === 'black'
            ? '(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)'
            : '(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)'
    return `linear-gradient(rgba${gradient}), url(${imageUrl})`
}

export const getHerobannerGradient = (desktopAlignment, variant, isMaskHeaderActive) => {
    if (!variant) return null
    const opacity = isMaskHeaderActive ? '0.5' : '0.2'
    const color = variant === 'white' ? '255, 255, 255' : '0, 0, 0'
    const alignmentDegrees = {
        'middle-left': 270,
        'middle-right': 90,
        'middle-center': 0,
        'top-center': 0,
        'bottom-center': 180,
    }

    const gradientTemplate = (deg) =>
        desktopAlignment === 'middle-center'
            ? `linear-gradient(${deg}deg, rgba(${color}, ${opacity}) 100%, rgba(${color}, ${opacity}) 100%)`
            : `linear-gradient(${deg}deg, rgba(${color}, 0) 0%, rgba(${color}, ${opacity}) 100%)`

    return gradientTemplate(alignmentDegrees[desktopAlignment] ?? 180)
}

export const getMediaHeight = (contentHeight) => {
    if (typeof contentHeight !== 'string' && typeof contentHeight !== 'number') return

    const heightMapping = {
        big: remCalc(800),
        mid: remCalc(640),
        small: remCalc(460),
        auto: 'auto',
    }

    return heightMapping[contentHeight] || remCalc(contentHeight)
}

export const getAlignmentStyles = (alignment = 'middle-center', styles) => {
    // Fallback to 'middle-center' in case alignment is of a falsy value
    return styles.alignment[alignment] || styles.alignment['middle-center']
}
export const calculateVerticalPadding = (direction, hasPaddings) => {
    if (direction === 'column') return 'unset'
    if (direction === '' && hasPaddings)
        return {
            base: remCalc(40),
            md: remCalc(24),
            lg: remCalc(0),
        }
    return remCalc(hasPaddings ? 40 : 0)
}

/**
 * Extracts video URLs from the first hero banner component in a page's component list.
 * Used to generate SSR-side preload hints for LCP optimization.
 *
 * @param {Array<{_content_type_uid: string, videos?: {desktop?: string, mobile?: string}}>} components - Array of page editorial components
 * @param {string} [baseUrl=''] - Base URL to prepend to video paths (e.g. 'https://www.delonghi.com' on localhost)
 * @returns {{desktop: string|null, mobile: string|null}|null} Video URLs object or null if first component is not a hero banner or has no videos
 *
 * @example
 * // Standard usage
 * getFirstHeroBannerVideo(entries?.editorial_components)
 * // → { desktop: '/videos/hero-desktop.mp4', mobile: '/videos/hero-mobile.mp4' }
 *
 * @example
 * // Localhost usage with base URL
 * getFirstHeroBannerVideo(entries?.editorial_components, 'https://www.delonghi.com')
 * // → { desktop: 'https://www.delonghi.com/videos/hero-desktop.mp4', mobile: 'https://www.delonghi.com/videos/hero-mobile.mp4' }
 *
 * @example
 * // First component is not a hero banner
 * getFirstHeroBannerVideo([{ _content_type_uid: 'promo_slider' }])
 * // → null
 */
export const getFirstHeroBannerVideo = (components = [], baseUrl = '') => {
    if (!components.length) return null

    const HERO_TYPES = ['herobanner', 'hero_banner', 'coffee_lounge_component']
    const heroBannerWithVideo = components.find(
        (c) =>
            HERO_TYPES.includes(c?._content_type_uid) && (c?.videos?.desktop || c?.videos?.mobile),
    )

    if (!heroBannerWithVideo) return null

    return {
        desktop: heroBannerWithVideo.videos.desktop
            ? `${baseUrl}${heroBannerWithVideo.videos.desktop}`
            : null,
        mobile: heroBannerWithVideo.videos.mobile
            ? `${baseUrl}${heroBannerWithVideo.videos.mobile}`
            : null,
    }
}
